import { useWatch, type Control, type UseFieldArrayUpdate } from 'react-hook-form'

import { scopedTranslation } from '@utils/I18n'

import { SelectField } from '@components/molecules/SelectField'

import { type FilterFormValues } from './FilterDialog'
import { type AvailableFilters, initialValues } from './stores/filterStoreSlice'

const t = scopedTranslation('components.filter_dialog')

export type FieldProps = {
  index: number
  filteringOptions: AvailableFilters
  control: Control<FilterFormValues>
  update: UseFieldArrayUpdate<FilterFormValues, 'rules'>
}

const PropertyField = ({ control, index, filteringOptions, update }: FieldProps) => {
  const filter = useWatch({ control, name: `rules.${index}` })
  const fieldName = `rules.${index}` as const

  return (
    <SelectField
      className="tw:h-full"
      search
      hideLabel
      name={fieldName}
      label={t('labels.property')}
      options={Object.keys(filteringOptions).map((value) => ({
        value,
        label: filteringOptions[value].label,
      }))}
      onValueChange={(property) => {
        const [predicate] = filteringOptions[property].predicates
        update(index, { property, predicate: predicate.value, values: initialValues(predicate) })
      }}
      value={filter.property}
    />
  )
}

export default PropertyField
